module.exports = __webpack_public_path__ + "static/09-89dd91f6f1e8a90fc6af52d3520052fe.jpg";